import React, { useLayoutEffect, useRef, useState } from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { gsap } from 'gsap'

import CloseIcon from 'svgs/close.svg'
import SingleCast from './SingleCast'

export default function Cast() {
  const [bioOpen, setBioOpen] = useState(false)
  const [desktopCast, setDesktopCast] = useState('')
  const { cast } = useStaticQuery(graphql`
    query {
      cast: allCastJson {
        nodes {
          name
          role
          bio
          image {
            childImageSharp {
              gatsbyImageData(placeholder: DOMINANT_COLOR, quality: 100)
            }
          }
        }
      }
    }
  `)
  const data = cast.nodes

  const target = useRef()
  const tl = useRef()
  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      tl.current = gsap
        .timeline()
        .to(target.current, {
          visibility: 'visible',
          height: 'auto',
          opacity: 1,
        })
        .to('.fade', {
          opacity: 1,
        })
    }, target)
  }, [])
  useLayoutEffect(() => {
    if (!bioOpen) {
      tl.current.timeScale(2)
      tl.current.reverse()
    } else {
      tl.current.timeScale(1)
      tl.current.play()
    }
  }, [bioOpen])

  const handleClose = () => {
    setBioOpen(false)
    window.location.hash = `#top`
  }
  return (
    <>
      <div className="bg-black relative">
        <span id="top" className="absolute top-[-4rem]" />
        <div className="py-12 cast-grid">
          {/* <div className="w-11/12 mx-auto container py-12"> */}
          {data.map((cast, i) => (
            <SingleCast
              data={cast}
              key={i}
              index={i + 1}
              setBioOpen={setBioOpen}
              setDesktopCast={setDesktopCast}
            />
          ))}
        </div>
      </div>
      <div
        ref={target}
        className="relative w-full bg-white invisible opacity-0 h-0"
      >
        <span id={desktopCast.name} className="absolute top-[-6.5rem]" />
        <div className="  py-8 text-center max-w-[700px] mx-auto">
          <div
            className="blockTextStyling w-[90%] mx-auto"
            dangerouslySetInnerHTML={{ __html: desktopCast.bio }}
          />
          <div className="text-center mx-auto close-icon">
            <CloseIcon onClick={() => handleClose()} />
          </div>
        </div>
      </div>
    </>
  )
}
